import { Subscription } from 'rxjs';

export const SubscriptionsUtils = {
  /**
   * Unsubscribe from all subscriptions passed in parameter.
   * @param subscriptions
   */
  unsubscribe: (...subscriptions: Subscription[]): void => {
    for (const sub of subscriptions) {
      sub?.unsubscribe();
    }
  },
};
